import { plural } from '@cian/utils';
import * as React from 'react';

import styles from './AboutLayout.css';
import { NBSP } from '../../../constants';
import { TVillageOffersType } from '../../../constants/base';
import { ObjectsDisclaimerContainer } from '../../../containers/ObjectsDisclaimer';
import { PriceDisclaimerContainer } from '../../../containers/PriceDisclaimerContainer';
import { rangePrice } from '../../../utils/helpers';
import { BuilderIcon } from '../../common/icons/builder_icon';
import { Card } from '../card';

const OBJECT_VARIANTS: [string, string, string] = ['объект', 'объекта', 'объектов'];

export interface IAboutLayoutProps {
  builderName?: string;
  counterInSale: number;
  counterTotal?: number;
  finishYearMax?: number;
  finishYearMin?: number;
  name: string;
  priceMax?: number;
  priceMin?: number;
  isFat?: boolean;
  isCroppedCard?: boolean;
  offersType: TVillageOffersType | undefined;
}

export class AboutLayout extends React.Component<IAboutLayoutProps> {
  public render() {
    const { builderName, name, priceMax, priceMin, isFat, isCroppedCard } = this.props;
    const hasPrice = !!(priceMin || priceMax);

    return (
      <Card joinBottom={!isFat} isFatGalleryEnabled={isFat} dataName="ShortInfo">
        <h1 className={styles['title']}>Коттеджный посёлок «{name}»</h1>
        <div className={styles['description']}>{this.description}</div>
        <ObjectsDisclaimerContainer />
        {!isCroppedCard && hasPrice ? (
          <div className={styles['price']} data-name="Price">
            {rangePrice(priceMin, priceMax)}
            <PriceDisclaimerContainer size="20" mediaType="mobile" />
          </div>
        ) : (
          <div>Цена уточняется у{NBSP}застройщика</div>
        )}
        {builderName && (
          <div className={styles['builder']}>
            <span className={styles['builder_icon']}>
              <BuilderIcon />
            </span>
            <span className={styles['builder_name']}>Застройщик {builderName}</span>
          </div>
        )}
      </Card>
    );
  }

  private get description(): string {
    const { counterTotal, counterInSale, offersType } = this.props;

    const totalObjects =
      counterTotal && counterTotal > 0 && counterInSale > 0 && offersType && offersType !== 'resale'
        ? `${counterTotal}${NBSP}${plural(counterTotal, OBJECT_VARIANTS)}`
        : '';
    const objectsOnSale = counterInSale > 0 && offersType ? `${counterInSale}${NBSP}в${NBSP}продаже` : '';

    return [this.finishDate, totalObjects, objectsOnSale].filter(Boolean).join('  ·  ');
  }

  private get finishDate(): string | undefined {
    const { finishYearMin, finishYearMax } = this.props;

    let finishYear;

    if (!finishYearMin) {
      finishYear = finishYearMax ? String(finishYearMax) : undefined;
    }

    finishYear = finishYearMin === finishYearMax ? finishYearMax : `${finishYearMin}—${finishYearMax}`;

    return finishYear ? `Срок${NBSP}сдачи${NBSP}${finishYear}` : undefined;
  }
}
